// Single source of truth for the allowed-environments enum (GH #1013) —
// previously hand-maintained in 4 separate places with no shared source:
// workspaces/infra-clone/opa/data/environments.json, the vendored
// vault-gitops copy, vault-requests's VaultOnboardingForm.tsx ENVIRONMENTS
// constant, and vault-backend's manifestSchemas.ts environmentSchema.
//
// The OPA data files stay independently maintained for now — they're a
// different ecosystem (a JSON file rego reads natively, not a TS import) —
// tracked as its own follow-up: GH #1024 proposes making OPA the live
// source of truth instead, which would eventually supersede this constant
// entirely rather than sync alongside it.
export const ALLOWED_ENVIRONMENTS = [
  'production',
  'non-production',
  'development',
] as const;

export type Environment = (typeof ALLOWED_ENVIRONMENTS)[number];
